export default function toSingularCategory(pluralWord: string | null): string {
  switch (pluralWord) {
    case 'publications':
      return 'publication'
    case 'defenses':
      return 'defense'
    case 'blog':
      return 'blog'
    case 'awards':
      return 'award'
    case 'careers':
      return 'career'
    case 'events':
      return 'event'
    default:
      return ''
  }
}
